import { render, staticRenderFns } from "./pacs.vue?vue&type=template&id=3a7d1c3a&scoped=true"
import script from "./pacs.vue?vue&type=script&lang=js"
export * from "./pacs.vue?vue&type=script&lang=js"
import style0 from "./pacs.vue?vue&type=style&index=0&id=3a7d1c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7d1c3a",
  null
  
)

export default component.exports